import { CommonModule, NgClass } from '@angular/common';
import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import {
  FocusAiService,
  FocusAIUploadedFile,
} from '../../services/focus-ai.service';
import { MessageDialogComponent } from '@app/shared/message-dialog/message-dialog.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'rn-focus-ai-file-item',
  standalone: true,
  imports: [CommonModule, NgClass, MessageDialogComponent],
  templateUrl: './focus-ai-file-item.component.html',
  styleUrl: './focus-ai-file-item.component.scss',
})
export class FocusAiFileItemComponent implements OnInit {
  @Input({ required: true }) clientId: string;
  @Input({ required: true }) messageId: string;
  @Input({ required: true }) file: FocusAIUploadedFile;

  @ViewChild('deleteDialog', { static: true })
  deleteDialog: MessageDialogComponent;
  @ViewChild('errorDialog', { static: true })
  errorDialog: MessageDialogComponent;
  status: 'deleted' | 'error' | 'good' = 'good'; // Default status

  private focusAiService = inject(FocusAiService);
  constructor() {}

  ngOnInit(): void {
    // Todo: Display error message
    if ('reason' in this.file) {
      this.status = 'error';
    }
  }

  getIconForFileType(fileName: string): string {
    return this.focusAiService.getIconForFileType(fileName);
  }

  getSize(size: string): string {
    return this.focusAiService.getFileSize(size);
  }

  downloadFile(fileId: string) {
    this.focusAiService
      .getFileDownloadUrl(this.clientId, this.messageId, fileId)
      .subscribe({
        next: (response) => {
          window.open(response.url); // Open the file in a new tab
        },
        error: (error) => {
          console.error('Error fetching file download URL:', error);
        },
      });
  }

  deleteFile() {
    this.deleteDialog.showMessage();
  }

  closeDeleteDialog() {
    this.deleteDialog.close();
  }
  confirmDeleteFile() {
    this.focusAiService
      .deleteFile(this.clientId, this.messageId, this.file.id)
      .subscribe({
        next: (response) => {
          this.deleteDialog.close();
          this.status = 'deleted'; // Update status to deleted while waiting for the next poll. There's styling to hide the item
        },
        error: (error: HttpErrorResponse) => {
          this.deleteDialog.close();
          this.errorDialog.showMessage(
            error.error.reason || 'Error deleting file',
          );
        },
      });
  }
}
